import React , {Component} from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import PolicyPage from './policy';



class policy extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div>
            <PolicyPage/>
            </div>
        )
    }
}

export const Policy = PnkConnect(policy , '');